export function isMac(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }

  return (
    (navigator as { userAgentData?: { platform?: string } }).userAgentData
      ?.platform === "macOS" || Boolean(navigator.userAgent?.includes("Mac"))
  );
}
